import { z } from 'zod';
import { Transform } from 'libs/end-to-end/src/types/databases/transform/transform';

export const CreateTransformRequestBodySchema = Transform.omit({
  id: true,
  startedAt: true,
  details: true,
}).extend({
  scriptUserUploadId: z.string(),
});

export type CreateTransformRequestBodyType = z.infer<
  typeof CreateTransformRequestBodySchema
>;
